export const contactResultsInitialState = {
    status: 'idle',
    results: {

    },
    currentPage: 1,
    visiblePages: [],
    totalPages: 0,
    row: 50,
    first: 0,
    sort: null,
    filter: null, 
    refresh: false,
    works: {
        // Store works data by contactId for independent table instances
        byContactId: {
            // Structure: 
            // 'contactId': {
            //     status: 'idle',
            //     results: { total: 0, results: [] },
            //     currentPage: 1,
            //     totalPages: 0,
            //     row: 10,
            //     first: 0,
            //     sort: null,
            //     filter: null
            // }
        }
    }
}

export const contactResultsReducer = (state = contactResultsInitialState, action) => {
    switch (action.type) {
        case 'CONTACT_SET_FETCH_STATUS_ACTION':
            return {
                ...state,
                status: action.payload
            }
        case 'CONTACT_SET_FETCH_RESULTS_ACTION':
            return {
                ...state,
                results: action.payload
            }
        case 'CONTACT_SET_PAGINATION_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload
            }
        case 'CONTACT_SET_PAGINATION_TOTAL_PAGES':
            return {
                ...state,
                totalPages: action.payload
            }
        case 'CONTACT_SET_PAGINATION_ROWS':
            return {
                ...state,
                row: action.payload
            }
        case 'CONTACT_SET_PAGINATION_FIRST':
            return {
                ...state,
                first: action.payload
            }
        case 'CONTACT_SET_FILTER':
            return {
                ...state,
                filter: action.payload
            }
        case 'CONTACT_SET_SORT':
            return {
                ...state,
                sort: action.payload
            }
        case 'CONTACT_SET_REFRESH':
            return {
                ...state,
                refresh: action.payload
            }
        case 'CONTACT_SET_EXPORT_EXCEL':
            return {
                ...state,
                excelExport: {
                    searchTerm: action.payload,
                    status: 'pending'
                }
            }
        case 'CONTACT_WORKS_SET_FETCH_STATUS_ACTION':
            {
                const { contactId, status } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                status
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_SET_FETCH_RESULTS_ACTION':
            {
                const { contactId, results } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                results
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_SET_PAGINATION_CURRENT_PAGE':
            {
                const { contactId, currentPage } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                currentPage,
                                status: 'idle'  // Reset status to allow fetch
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_SET_PAGINATION_TOTAL_PAGES':
            {
                const { contactId, totalPages } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                totalPages
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_SET_PAGINATION_ROWS':
            {
                const { contactId, row } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                row,
                                status: 'idle'  // Reset status to allow fetch
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_SET_PAGINATION_FIRST':
            {
                const { contactId, first } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                first,
                                status: 'idle'  // Reset status to allow fetch
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_SET_FILTER':
            {
                const { contactId, filter } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                filter,
                                status: 'idle'  // Reset status to allow fetch
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_SET_SORT':
            {
                const { contactId, sort } = action.payload
                return {
                    ...state,
                    works: {
                        ...state.works,
                        byContactId: {
                            ...state.works.byContactId,
                            [contactId]: {
                                ...state.works.byContactId[contactId],
                                sort,
                                status: 'idle'  // Reset status to allow fetch
                            }
                        }
                    }
                }
            }
        case 'CONTACT_WORKS_INIT_CONTACT':
            {
                const { contactId } = action.payload
                // Initialize state for a new contact if it doesn't exist
                if (!state.works.byContactId[contactId]) {
                    return {
                        ...state,
                        works: {
                            ...state.works,
                            byContactId: {
                                ...state.works.byContactId,
                                [contactId]: {
                                    status: 'idle',
                                    results: { total: 0, results: [] },
                                    currentPage: 1,
                                    totalPages: 0,
                                    row: 10,
                                    first: 0,
                                    sort: null,
                                    filter: null
                                }
                            }
                        }
                    }
                }
                return state
            }
        default:
            return state
        }
}
